<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Activities"></app-breadcrumb>

        <!-- page heading -->
        <div class="row mb-2">
            <div class="col-lg-8 col-md-7 col-12">
                <p>
                    <span class="h3 md-small-text">Transaction Logs</span> <br> 
                    <span class="d-none d-md-block">(a track record of your shop activities)</span>
                </p>
            </div>
            <div class="col-lg-4 col-md-5 col-12">
                <div class="bg-grey text-center form-control">
                    <select @change="modifyLimit(recordsLimit)" v-model="recordsLimit">
                        <option v-for="(x, i) in countRecords.steps" :key="i" :value="x">{{x}}</option>
                    </select> 
                    of {{countRecords.total}} Records
                </div>
            </div>
        </div>

        <!-- statement -->
        <div class="row">
            <div class="col-12">
                <div class="table-responsive">
                    <table class="table table-striped mt-2">
                        <thead class="bg-silver">
                            <tr>
                                <th scope="col">No.</th>
                                <th scope="col">Event</th>
                                <th scope="col">Number</th>
                                <th scope="col">Time</th>
                                <th scope="col">View</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(transaction, i) in myTransactions" :key="transaction.id" @click="viewSingleTransaction(transaction.id)" class="clickable">
                                <th scope="row">{{ i+1 }}.</th>
                                <td><span class="text-truncate">{{transaction.event | capitalize}} </span></td>
                                <td>{{transaction.number}}</td>
                                <td class="text-truncate">{{transaction.joined | moment("MMM D 'YY")}}</td>
                                <td class="text-center"><i class="fas fa-envelope-open-text text-dark-green"></i></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- view a selected transaction -->
        <app-transaction-details :transactionId="selectedId"></app-transaction-details>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { paginateRecords } from '@/store/dry'

import Breadcrumb from '../shared/Breadcrumb.vue'
import TransactionDetails from '@/components/user/pages/transactionsParts/TransactionDetails.vue'
import LayoutShop from '@/layouts/Shop.vue'

export default {
    name: "Activities",
    data() {
        return {
            selectedId: '',
            recordsLimit: 0,
        }
    },
    methods: {
        ...mapActions(['fetchTransactions']),
        viewSingleTransaction(transactionId) {
            this.selectedId = transactionId
        },
        modifyLimit(limit) {
            this.recordsLimit = limit
        }
    },
    computed: {
        ...mapGetters(['transactions', 'user']),
        myTransactions() {
            if(this.transactions && this.transactions !== null){
                return this.transactions.slice(0, this.recordsLimit)
            }
            return false
        },
        countRecords() {
            if(this.transactions && this.transactions.length){
                let resultObj = paginateRecords(this.transactions, 9)
                this.recordsLimit = resultObj.steps[0]
                return resultObj
            }
            return false
        },
    },
    components: {
        appBreadcrumb: Breadcrumb,
        appTransactionDetails: TransactionDetails
    },
    created() {
        this.fetchTransactions().then(() => {}).catch((e) => {})
        this.$emit('update:layout', LayoutShop);
    }
}
</script>